export const Attributes = {
    name: 'name',
    title: 'title',
    buyerTitle: 'buyer_title',
    options: 'options',
    label: 'label',
    tooltip: 'tooltip',
    buyerDescription: 'buyer_description'
};
